import CameraIcon from "../../assets/img/photobooth/camera.png";
import { Link } from "react-router-dom";
import React from "react";
import {FrontendRoutes} from "../../constants";

const PhotoBooth = () => {
  const [width, setWidth] = React.useState(window.innerWidth * 0.05);
  const [fontSize, setFontSize] = React.useState(window.innerWidth> 900? 36: window.innerWidth * 0.02);
  React.useEffect(() => {
    function handleResize() {
      if (window.innerWidth > 900)
      {
        setWidth(window.innerWidth * 0.05)
        setFontSize(window.innerWidth * 0.02)
      }
      else {
        setWidth(window.innerWidth * 0.05)
        setFontSize(window.innerWidth * 0.02)
      }
    }
    window.addEventListener('resize', handleResize)
  })
  return (
    <div className="photobooth-link">
      <img src={CameraIcon} alt="" width={width * 0.4} />
      <Link to={FrontendRoutes.PHOTO_BOOTH} style={{ textDecoration: "underline", fontSize: '1.0vw' }}>
        Go To Photo Booth
      </Link>
    </div>
  );
};

export default PhotoBooth;
